import {Component, Input, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {LaboratoryNamespace} from '@namespaces/laboratory.namespace';
import ResponsibleStaffValue = LaboratoryNamespace.ResponsibleStaffValue;
import ResponsibleStaffFieldType = LaboratoryNamespace.ResponsibleStaffFieldType;

interface FieldValue {
    specialist_id: FormControl;
    required: boolean;
    label: string;
}

@Component({
    selector: 'app-responsible-staff',
    templateUrl: './responsible-staff.component.html',
    styleUrls: ['./responsible-staff.component.scss']
})
export class ResponsibleStaffComponent implements OnInit {

    @Input() rootFormGroup: FormGroup = new FormGroup({});

    public fbArray: FormArray = new FormArray([]);

    public fields: FieldValue[] = [];

    constructor(
        private route: ActivatedRoute,
        private fb: FormBuilder,
    ) {
    }

    ngOnInit() {
        this.rootFormGroup.setControl('responsible_staff', this.fbArray);

        this.merge();
    }

    private merge() {
        const types: ResponsibleStaffFieldType[] = this.route.snapshot.data.responsibleStaffTypes || [];
        const staff: ResponsibleStaffValue[] = this.route.snapshot.data.responsibleStaff || [];

        this.fields = types.map((type): FieldValue => {
            const currentValue = staff.find(s => s.type_staff === type.type_staff);

            const fbGroup = this.fb.group({
                id: [currentValue && currentValue.id || null],
                type_staff: [type.type_staff],
                specialist_id: [currentValue && currentValue.specialist_id || null]
            });

            this.fbArray.push(fbGroup);

            return {
                required: type.required,
                label: type.title,
                specialist_id: fbGroup.get('specialist_id') as FormControl,
            };
        });
    }
}
